module.exports = __webpack_public_path__ + "static/GTSuperDisplay-Regular-2d4464decf03c27b3cd32d5487f84000.svg";